<div class="rating-block">
  <div class="title">{{ title }}</div>
  <div class="icon-set" (mouseleave)="onHover(0)">
    @for (item of [].constructor(5); track item; let index = $index) {
      <div (click)="onItemSelected(index+1)"
        (mouseenter)="onHover(index+1)"
                 [ngClass]="{ 'star-inactive': hoverRange < index+1 ,
                               'star-active' : hoverRange >= index+1 ||  index+1 <= rating  }">
            </div>
        
}
    </div>
</div>
